<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-8 col-lg-5 mx-auto text-center">
        <div class="login_container">
          <div class="mb-3">
            <img alt="logo" class="logo" src="../../assets/img/logo.jpg">
          </div>
          <transition name="fade" mode="out-in">
            <form key="1" v-if="state === 1" name="login" @submit.prevent="mobileSubmit">
              <h4 class="my-3">ورود با موبایل</h4>
              <div class="form-group">
                <fvSelect class="form-control text-right fv-size-md"
                          placeholder="کد کشور"
                          v-model="country_code"
                          text-key="name" value-key="dCode"
                          :options="country_option">

                  <template slot="value" slot-scope="scope">
                    {{scope.option.name}} (+{{scope.option.dCode}})
                  </template>

                </fvSelect>

              </div>
              <div class="form-group input-group">
                <fg-input v-model="item.mobile" placeholder="شماره موبایل به صورت 09120000000"
                          addon-right-icon="fas fa-mobile-alt icon font-25 no_border no_border">
                </fg-input>
              </div>


              <button :disabled="countdownTimer || loading" class="btn btn-success w-100 mb-3" type="submit">
                <span v-if="!loading">ادامه</span>
                <i v-else class="spinner sm"/>
                <span v-if="countdownTimer">{{' ' + countdownTimer + ' '}}</span>

              </button>
              <div class="row">
                <div class="col-12 col-md-6 mt-2 w-100 text-right">
                  <a @click.prevent="state = 2">
                    ورود با نام کاربری
                  </a>
                </div>
              </div>

            </form>
            <form key="2" v-else-if="state === 2" name="login" @submit.prevent="userNameSubmit">
              <h4 class="my-3">ورود با نام کاربری</h4>

              <div class="form-group input-group">
                <fg-input v-model="item.username" placeholder="نام کاربری"
                          addon-right-icon="fas fa-user icon font-25 no_border no_border">
                </fg-input>
                <fg-input type="password" v-model="item.password" placeholder="رمز عبور"
                          addon-right-icon="fas fa-lock icon font-25 no_border no_border">
                </fg-input>
              </div>

              <button :disabled="loading" class="btn btn-success w-100 mb-3" type="submit">
                <span v-if="!loading">ورود</span>
                <i v-else class="spinner sm"/>
              </button>
              <div class="row">
                <div class="col-12 col-md-6 mt-2 w-100 text-right">
                  <a @click.prevent="state = 1">
                    ورود با موبایل
                  </a>
                </div>
                <!--                <div class="col-12 col-md-6 font-12 mt-2 w-100 text-left">-->
                <!--                  <router-link :to="{ name: 'dashboard' }">-->
                <!--                    رمز عبور خودرا فراموش کرده اید؟-->
                <!--                  </router-link>-->
                <!--                </div>-->

              </div>

            </form>
            <form key="3" v-else-if="state === 3" name="login2" @submit.prevent="smsCodeSubmit">
              <div class="form-group input-group">
                <fg-input v-model="item.code" placeholder="کد تایید"
                          addon-right-icon="fas fa-user-check icon font-25 no_border no_border">
                </fg-input>
              </div>

              <button :disabled="loading" class="btn btn-success w-100 mb-3" type="submit">
                <span v-if="!loading">ورود</span>
                <i v-else class="spinner sm"/>
              </button>
              <div class="row">
                <div class="col-12 col-md-6 mt-2 w-100 text-right">
                  <a @click.prevent="state = 1">
                    تغییر شماره
                  </a>
                </div>
              </div>
            </form>
          </transition>
        </div>
      </div>
    </div>
  </div>


</template>

<script>

	const countryCode = require("../../../static/country.json")
	import {mapActions} from 'vuex'
	import {_setAuthData} from '../../services/utils'

	export default {
		components: {},
		mounted() {
		},
		data() {

			return {
				item: {},
				state: 1,
				loading: false,
				country_option: countryCode,
				country_code: "98",
				countdownTimer: 0,
				...mapActions('main', [
					'crud',
				]),
			}
		},
		methods: {
			async mobileSubmit() {
				this.loading = true
				const mobile = `(${this.country_code})${this.item.mobile}`
				try {
					const result = await this.crud({
						action: 'post',
						section: 'auth/otp',
						data: {mobile: mobile},
						showError: true,
						auth: false,
					})
					if (result.status === 204) {
						// this.countdownTimer = this.countdown(60)
						this.state = 3
					}
				} catch (e) {
					// this.countdownTimer = this.countdown(60)
					console.log(e)
				} finally {
					this.loading = false
				}
			},
			async userNameSubmit() {
				this.loading = true
				try {
					const result = await this.crud({
						action: 'post',
						section: 'auth/password',
						data: {key: this.item.username, pass: this.item.password},
						auth: false,
					})
					// TODO show related error below
					if (result.status !== 200)
						return false

					await this.login(result)
				} catch (e) {
					console.log(e.response)
				} finally {
					this.loading = false
				}
			},
			async smsCodeSubmit() {
				this.loading = true
				const mobile = `(${this.country_code})${this.item.mobile}`
				try {
					const result = await this.crud({
						action: 'post',
						section: 'auth/otp/verify',
						data: {mobile: mobile, code: this.item.code, include_roles: true},
						auth: false,
						showError: true
					})
					// TODO show related error below
					if (result.status !== 200)
						return false

					await this.login(result)
				} catch (e) {
					console.log(e)
				} finally {
					this.loading = false
				}
			},

			async login(result) {
				const data = result.data
				await _setAuthData({
					accessToken: data.access_token,
					refreshToken: data.refresh_token,
					expireIn: data.expires_in
				}, true)

				return this.$router.push({name: 'dashboard'})
			},
			async countdown(timeDistance) {
				let time = setInterval(() => {
					timeDistance--
					if (timeDistance <= 0 || !timeDistance) {
						clearInterval(time)
						this.countdownTimer = 0
						return
					}
					let minutes = Math.floor(timeDistance / 60)
					let seconds = Math.floor(timeDistance % 60)

					let x = minutes + ':' + seconds
					this.countdownTimer = x
				}, 1000)
			}
		}
	};
</script>
<style lang="scss">
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0
  }

</style>
